// extracted by mini-css-extract-plugin
module.exports = {"card":"P_b4","info":"P_P","cardText":"P_b5","imageContainer":"P_br"};